import { createContext } from "react";
import type { EventUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";

export const EventPagesContext = createContext<
	EventUmbPageContentResponseModel[] | undefined
>(undefined);
